import React from 'react';
import { Navbar as BootstrapNavbar, Nav, Container, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import BrandMark from './BrandMark';

const PublicNavbar: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const userInitial = (user?.username || 'U').charAt(0).toUpperCase();

  return (
    <BootstrapNavbar className="app-navbar public-navbar" variant="light" expand="lg" sticky="top">
      <Container fluid="xl" className="app-navbar__inner">
        <LinkContainer to="/">
          <BootstrapNavbar.Brand className="app-brand">
            <span className="app-brand__mark"><BrandMark /></span>
            <span>StockHunt</span>
          </BootstrapNavbar.Brand>
        </LinkContainer>
        
        <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" />
        <BootstrapNavbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#features">Product</Nav.Link>
            <Nav.Link href="#markets">Markets</Nav.Link>
            <Nav.Link href="#security">Security</Nav.Link>
            <LinkContainer to="/help">
              <Nav.Link>Help</Nav.Link>
            </LinkContainer>
          </Nav>
          
          <Nav>
            {user ? (
              <div className="d-flex align-items-center gap-3">
                <span className="app-user-menu">
                  <span className="app-user-menu__avatar" aria-hidden="true">{userInitial}</span>
                  <span>{user.username}</span>
                </span>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => navigate('/dashboard')}
                >
                  Go to Dashboard
                </Button>
              </div>
            ) : (
              <div className="d-flex gap-2">
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => navigate('/login')}
                >
                  Login
                </Button>
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => navigate('/register')}
                >
                  Sign Up
                </Button>
              </div>
            )}
          </Nav>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
};

export default PublicNavbar;
